export default {
  reduxLogging: process.env.NODE_ENV !== 'production',
  showDevScreens: process.env.NODE_ENV !== 'production',
  showTrackingLogs: process.env.NODE_ENV !== 'production',
  useFixtures: false
};
